<script>
import { Bar } from 'vue-chartjs'

export default {
  extends: Bar,
  props: ['data', 'labels'],
  watch: {
    data: function () {
      this.renderProducaoChart()
    }
  },
  methods: {
    renderProducaoChart () {
      this.renderChart({
        labels: this.labels,
        datasets: [
          {
            label: 'Produção (KG)',
            backgroundColor: 'rgba(33, 147, 176, 0.8)',
            borderColor: '#2193b0',
            borderWidth: 1,
            data: this.data,
            maxBarThickness: 35,
            borderRadius: 4
          }
        ]
      }, {
        maintainAspectRatio: false,
        responsive: true,
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            gridLines: {
              drawOnChartArea: false
            }
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        },
        onClick: (evt, item) => {
          if (item && item.length > 0) {
            const index = item[0]._index
            const day = this.labels[index]
            this.$emit('day-selected', day)
          } else {
            this.$emit('day-selected', null)
          }
        }
      })
    }
  },
  mounted () {
    this.renderProducaoChart()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/producao/producao-dashboard/ProducaoMensalChart.vue